export default __webpack_public_path__ + "static/apple-touch-icon-5582de3006f29861c4bf67c4fbf3eb5d.png";